function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import numeral from 'numeral';
import { ListingType, RentListingTypeKeys } from '@domain-group/fe-allhomes-library/lib/node';
var NUMERAL_FORMAT = '($0[.]0a)';
var getLabelByListingType = listingType => ({
  [ListingType.SALES_RESIDENTIAL.name]: 'Buy',
  [ListingType.RENTAL_RESIDENTIAL.name]: 'Rent',
  [ListingType.SHARE_RESIDENTIAL.name]: 'Share',
  [ListingType.DEVELOPMENTS_RESIDENTIAL.name]: 'New Homes'
})[listingType];
var formatPriceRangeString = range => {
  var numeralDefaultLocale = numeral.locales.en;
  if (numeralDefaultLocale && numeralDefaultLocale.abbreviations) {
    numeralDefaultLocale.abbreviations.million = 'mil';
    numeralDefaultLocale.abbreviations.billion = 'bil';
    numeralDefaultLocale.abbreviations.trillion = 'tri';
  }
  if (range.min && range.max) {
    return "".concat(numeral(range.min).format(NUMERAL_FORMAT), " - ").concat(numeral(range.max).format(NUMERAL_FORMAT));
  }
  if (range.min) {
    return "from ".concat(numeral(range.min).format(NUMERAL_FORMAT));
  }
  if (range.max) {
    return "up to ".concat(numeral(range.max).format(NUMERAL_FORMAT));
  }
  return undefined;
};
var formatFeatureRangeString = (range, singular, plural) => {
  var isSingular = range.min && range.min === 1 && range.max && range.max === 1;
  var descriptor = isSingular ? singular : plural;
  if (range.min && range.max) {
    if (range.min === range.max) {
      return "".concat(range.min, " ").concat(descriptor);
    }
    return "".concat(range.min, "-").concat(range.max, " ").concat(descriptor);
  }
  if (range.min) {
    return "".concat(range.min, "+ ").concat(descriptor);
  }
  if (range.max) {
    return "0-".concat(range.max, " ").concat(descriptor);
  }
  return undefined;
};
export var buildFilterSummary = query => {
  var parts = [];
  parts.push(getLabelByListingType(query.filters.listingType));
  var priceValue = query.filters.price.value;
  if (priceValue && (priceValue.min || priceValue.max)) {
    parts.push(formatPriceRangeString(priceValue));
  }
  [['bed', 'beds', 'beds'], ['bath', 'baths', 'baths'], ['car', 'cars', 'parking']].forEach(type => {
    var _type = _slicedToArray(type, 3),
      singular = _type[0],
      plural = _type[1],
      filterName = _type[2];
    var filterValue = query.filters[filterName].value;
    if (filterValue && (filterValue.min || filterValue.max)) {
      parts.push(formatFeatureRangeString(filterValue, singular, plural));
    }
  });
  if (RentListingTypeKeys.includes(query.filters.listingType)) {
    var availability = query.filters.availability.value;
    if (availability) {
      if (availability.min) {
        parts.push("after ".concat(availability.min));
      } else if (availability.max) {
        parts.push("before ".concat(availability.max));
      }
    }
  }
  return parts.join(' • ');
};